import { authActionTypes } from "../actions/auth.actions";

export default function authReducer(state = null, action) {
  switch (action.type) {
    case authActionTypes.FETCH_CHECK_SUPERVISOR:
      // if (action.) {
        return { ...state, authData: action.data.navItems };
      // } else {
        // return { ...state, anonymousNav: action.data.navItems }; //TODO:  REMOVE THIS IF NOT REQURIED
      // }

    case authActionTypes.VALIDATE_TOKEN_SUCCESS:
      return {
        ...state,
        isAuth: action.isAuth,
        token: action.token,
        userType: action.userType,
        changePasswordRequired: action.changePasswordRequired,
      };

    case authActionTypes.CHANGE_PASSWORD_TOKEN_SUCCESS:
      return {
        ...state,
        isAuth: action.isAuth,
        token: action.token,
      };

    case authActionTypes.CUSTOMER_ARCHIVE_SUCCESS:
      return {
        ...state,
        archiveData: action.data
      };

    case authActionTypes.ACCOUNT_DETAILS_SUCCESS:
      return {
        ...state,
        accountDetails: action.data
      };

    default:
      return state;
  }
}
